var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtLogoOrig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1584,
    height: 792,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2354,
    y: 842,
    width: 1584,
    height: 792
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2354 -842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3268.77 977.434C3598.36 977.434 3865.54 1094.09 3865.54 1238 3865.54 1381.91 3598.36 1498.57 3268.77 1498.57 2939.19 1498.57 2672 1381.91 2672 1238 2672 1094.09 2939.19 977.434 3268.77 977.434ZM3786.24 842C3835.68 842 3884.54 842.693 3932.68 844.044L3938 844.269 3801.11 850.045C3148.46 886.971 2657.51 1046.63 2657.51 1238 2657.51 1429.37 3148.46 1589.03 3801.11 1625.95L3938 1631.73 3932.68 1631.96C3884.54 1633.31 3835.68 1634 3786.24 1634 2995.24 1634 2354 1456.7 2354 1238 2354 1019.29 2995.24 842 3786.24 842Z",
    fill: "#CCCC00",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtLogoOrig);
export default __webpack_public_path__ + "static/media/etLogo_orig.b2607f6cb35a4ab47b07930e714a5cdd.svg";
export { ForwardRef as ReactComponent };